// Routes whose tables are discriminated by an `entity` query param. Default
// RUM view names are path-based, so accounts, lots, and sleeves would all
// collapse into a single `/views` view and be indistinguishable in dashboards.
const ENTITY_DISCRIMINATED_PATHS = new Set(['/views'])

// Entity params are snake_case identifiers (e.g. `account`, `lot`,
// `streaming_position`). Rejecting anything else bounds view-name cardinality.
const ENTITY_PARAM_PATTERN = /^[a-z][a-z0-9_]{0,39}$/

/**
 * Returns a per-entity RUM view name (e.g. `/views/account`) for URLs on
 * entity-discriminated routes, or `undefined` when the default view name
 * should be kept.
 */
export function getEntityViewName(
  viewUrl: string | undefined,
): string | undefined {
  if (viewUrl === undefined || viewUrl === '') {
    return undefined
  }

  let url: URL
  try {
    url = new URL(viewUrl)
  } catch {
    return undefined
  }

  if (!ENTITY_DISCRIMINATED_PATHS.has(url.pathname)) {
    return undefined
  }

  const entity = url.searchParams.get('entity')
  if (entity === null || !ENTITY_PARAM_PATTERN.test(entity)) {
    return undefined
  }

  return `${url.pathname}/${entity}`
}
